export default __webpack_public_path__ + "static/media/internalbleed3.8cf1c56a.png";